import { gql } from "@apollo/client";

export const GET_MONTOS_LIQUIDACIONES_ANTERIORES = gql`
    query montosLiquidacionesAnteriores($input: MontosLiquidacionFiltersInput!) {
        montosLiquidacionesAnteriores(input: $input) {
            success
            error
            valorEsperado {
                totalMesAnterior
                totalMesAnteAnterior
            }
        }
    }
`;